import { apiInstance } from 'api/utils';

export default {
  getCipTemplate: ({
    portfolio,
    policyId
  }: {
    portfolio: any;
    policyId: string;
  }) =>
    apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/cip/templates/?policy=${policyId}`
    }),
  getCipFunds: () =>
    apiInstance.request({
      method: 'GET',
      url: `/funds/cip/`
    }),
  getCipThresholds: () =>
    apiInstance.request({
      method: 'GET',
      url: '/config/cip-thresholds/'
    }),
  getPopulatedCipThresholds: () =>
    apiInstance.request({
      method: 'GET',
      url: '/config/cip-thresholds/populated'
    }),
  getCipRelations: (data: CipRelationsRequest) =>
    apiInstance.request({
      method: 'POST',
      url: '/cip-relations',
      data
    }),
  updateCipRelations: (data: any) =>
    apiInstance.request({
      method: 'POST',
      url: '/update-cip-relations',
      data
    }),
  deleteCipRelations: (data: any) =>
    apiInstance.request({
      method: 'DELETE',
      url: '/update-cip-relations',
      data
    }),
  getCipCatgories: () =>
    apiInstance.request({
      method: 'GET',
      url: '/search-cip-categories'
    }),
  getMpsFirms: () =>
    apiInstance.request({
      method: 'GET',
      url: '/search-mps-firms'
    }),
  getModelPortfolioSelections: (params?: {
    page: any;
    search?: string;
    firm_name?: string;
    cip?: number;
  }) =>
    apiInstance.request({
      method: 'GET',
      url: '/search-model-portfolio-selections/',
      params
    }),
  filterModelPortfolioSelections: (payload: any = {}) =>
    apiInstance.request({
      method: 'POST',
      url: '/model-portfolio-selection/search/',
      params: {
        page: payload?.params?.page,
        pageSize: payload?.params?.pageSize || 25
      },
      data: { filters: payload.filters, sorting: payload.sorting }
    }),
  getModelPortfolioSelectionOptions: () =>
    apiInstance.request({
      method: 'GET',
      url: '/model-portfolio-selection/options/'
    }),
  createModelPortfolioSelection: (data: any) =>
    apiInstance.request({
      method: 'POST',
      url: '/create-model-portfolio',
      data
    }),
  bulkUploadModelPortfolio: (data: any) =>
    apiInstance.request({
      method: 'POST',
      url: '/bulk-upload-model-portfolio',
      data
    }),
  deleteModelPortfolioDefinition: (id: number) =>
    apiInstance.request({
      method: 'DELETE',
      url: `/model-portfolio-definitions/${id}/`
    }),
  createCipThreshold: (data: any) =>
    apiInstance.request({
      method: 'POST',
      url: '/cip-threshold',
      data
    }),
  deleteCipThreshold: (data: any) =>
    apiInstance.request({
      method: 'delete',
      url: '/cip-threshold',
      data
    }),
  getCipThresholdRiskMap: () =>
    apiInstance.request({
      method: 'GET',
      url: 'cip-threshold'
    }),
  riskMapCip: (data: CipRelationsRequest) =>
    apiInstance.request({
      method: 'POST',
      url: 'risk-mapping',
      data
    })
};

export interface CipRelationsRequest {
  cip_thresholds: number[] | null;
}
